import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalModuleTableComponent } from './portal-module-table.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@NgModule({
  declarations: [
    PortalModuleTableComponent
  ],
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule
  ],
  exports: [
    PortalModuleTableComponent
  ]
})
export class PortalModuleTableModule { }
